import React from "react";
import { areas } from "../../helpers/areas";
import PropTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SearchIcon from "@material-ui/icons/Search";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import BusinessIcon from "@material-ui/icons/Business";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import StepConnector from "@material-ui/core/StepConnector";
import Button from "@material-ui/core/Button";
import { TabIngresoTitular } from "../afiliaciones/TabIngresoTitular";
import { Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import {
  aprobarPreafiliacionFamiliarBandeja,
  evaluarDocumentacionPresentadaFamiliares,
  observarPreafiliacionFamiliarBandeja,
} from "../../actions/preAfiliado/afiliado";
import { fetchGrupoFamiliar } from "../../actions/grupoFamiliar";
import { GrillaGrupoFamiliar } from "../afiliaciones/GrillaGrupoFamiliar";
import { fetchGrupoFamiliarPreinscripto } from "../../actions/grupoFamiliarPreinscripto";
import { AlertFinalizadoStepper } from "./AlertFinalizadoStepper";
import {
  enviarPreafiliadoFamiliarBandeja,
} from "../../actions/preAfiliado/bandeja";
import { changeStepper } from "../../actions/preAfiliado/stepper";
// import MuiAlert from "@material-ui/lab/Alert";
import { Redirect } from "react-router-dom";
// import { fetchAportes } from "../../actions/aportes";
import { limpiarSeleccionFamiliar } from "../../actions/familiarSeleccionado";
import { liberarPreAfiliacion } from "../../actions/preafiliacionesTomadas";
import { BannerAfiliado } from "../afiliaciones/BannerAfiliado";
import { startAlerta } from "../../actions/ui/alertas";
const ColorlibConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  completed: {
    "& $line": {
      backgroundImage:
        "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient(90deg, rgba(104,56,159) 47%, rgba(140,0,255,1) 100%);",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SearchIcon />,
    2: <GroupAddIcon />,
    3: <BusinessIcon />,
    4: <AssignmentIcon />,
    5: <PeopleAltOutlinedIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,

  completed: PropTypes.bool,

  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: 10,
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  buttonRoot: {
    margin: 30,
  },
  rootListadoc: {
    margin: 30,
  },
}));

function getStepsBandejaFamiliar() {
  return ["Datos Titular", "Familia"];
}
export default function CustomizedSteppersFamiliar({ fromBandeja }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(2);
  const [habilitado, setHabilitado] = React.useState(false);
  const [openObservacion, setOpenObservacion] = React.useState(false);
  const [observacion, setObservacion] = React.useState(false);
  const [redirectBandeja, setRedirectBandeja] = React.useState(false);
  const [redirectAfiliaciones, setRedirectAfiliaciones] = React.useState(false);
  const [mostrarNext, setMostrarNext] = React.useState(false);

  const [openAlert, setOpenAlert] = React.useState(false);
  const { step } = useSelector((state) => state.stepper);

  const steps = getStepsBandejaFamiliar();
  const { afiliadoEncontrado } = useSelector((state) => state.preinscripto);

  const { idArea: idAreaUsuario } = useSelector((state) => state.auth.areas[0]);
  const { itemsUsuario: preAfiliacionesTomadas } = useSelector((state) => state.preAfiliacionesTomadas);
  const { presentadaFamiliaresOk } = useSelector((state) => state.documentacionPresentada);
  const dispatch = useDispatch();

  const handleNext = () => {
    switch (step) {
      case 0:
        dispatch(changeStepper(step + 1));
        dispatch(evaluarDocumentacionPresentadaFamiliares(afiliadoEncontrado?.idGrupoFamiliar));
        break;
      case 1:
        dispatch(changeStepper(step + 1));
      
        setOpenAlert(true);
        break;
      default:
        break;
    }

    if (activeStep === steps.length - 1) {
      //alert("entre")
      //handleReset();
    }
  };

  const handleBack = () => {
    if (step === 4)
      dispatch(limpiarSeleccionFamiliar());
    if (step === 2) {
      setHabilitado(false);
    }
    dispatch(changeStepper(step - 1));
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);

    if (openObservacion) {
      setOpenObservacion(false);
      setOpenAlert(true);
    } else {
      if (idAreaUsuario === areas.Nacional)
        setOpenObservacion(true);
      else
        handleBack()
    }
  };

  const handleSend = () => {
    if (idAreaUsuario === areas.Nacional) {
      if (openAlert) {
       
        if(!presentadaFamiliaresOk) {
          dispatch(startAlerta('No se puede aprobar con documentacion faltante','warning','Atencion'));
        }else{
        dispatch(
          aprobarPreafiliacionFamiliarBandeja(
            afiliadoEncontrado?.id_afiliado,
            afiliadoEncontrado?.idGrupoFamiliar
          )
        );
      }
      }


      openObservacion && dispatch(
        observarPreafiliacionFamiliarBandeja(
          afiliadoEncontrado?.id_afiliado,
          afiliadoEncontrado?.idGrupoFamiliar,
          observacion
        )
      );
      setRedirectBandeja(true);
    } else {
      dispatch(
        enviarPreafiliadoFamiliarBandeja(
          afiliadoEncontrado?.id_afiliado, afiliadoEncontrado?.idGrupoFamiliar
        )
      );
      setRedirectAfiliaciones(true);
    }
    if (preAfiliacionesTomadas.length > 0)
      dispatch(liberarPreAfiliacion(preAfiliacionesTomadas[0].id));
  };

  const getStepContent = (escalon) => {
    switch (escalon) {
      case 0:
        return (
          (afiliadoEncontrado &&
            <TabIngresoTitular
              setMostrarNext={setMostrarNext}
              fromBandejaFamiliar={true}
              setActiveStep={() =>
                setActiveStep((prevActiveStep) => prevActiveStep + 1)
              }
            />
          )
        )
      case 1:
        dispatch(
          fetchGrupoFamiliarPreinscripto(afiliadoEncontrado.id_afiliado)
        );
       dispatch(fetchGrupoFamiliar(afiliadoEncontrado.id_Afil_R));
        return (
          <Grid className={classes.rootListadoc}>
            <GrillaGrupoFamiliar
              idGrupo="idGrupoFamiliarPreinscripto"
              fromBandejaFamiliar={true}
            />
          </Grid>
        );

      default:
        return "Unknown step";
    }
  };

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel
        activeStep={step}
        connector={<ColorlibConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <div>
        {step === steps.length ? (
          <div>
            <AlertFinalizadoStepper
              open={openAlert}
              pregunta={
                (idAreaUsuario === areas.Nacional)
                  ? "Aprobación / Observación"
                  : "¿Esta seguro que desea enviar la documentación?"
              }
              dialogText={
                (idAreaUsuario === areas.Nacional)
                  ? `Desea aprobar la pre afiliacion de ${afiliadoEncontrado.apellido_y_nombre}`
                  : "Recuerde que no podra modificar los datos. Aguarde que lo contacte un analista."
              }
              buttonCancel={
                (idAreaUsuario === areas.Nacional)
                  ? "Observar"
                  : "Cancelar"
              }
              buttonSubmit={
                (idAreaUsuario === areas.Nacional)
                  ? "Aprobar"
                  : "Enviar"
              }
              setObservacion={setObservacion}
              showTextarea={openObservacion}
              handleClose={handleCloseAlert}
              handleSend={handleSend}
            />
            {openObservacion && (
              <AlertFinalizadoStepper
                open={openObservacion}
                pregunta={"Observación de Pre-Afiliación"}
                dialogText={`Escriba el detalle del motivo de la observación de la Pre-Afiliación de ${afiliadoEncontrado.apellido_y_nombre}`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Grabar Observación"}
                showTextarea={openObservacion}
                setObservacion={setObservacion}
                handleClose={handleCloseAlert}
                handleSend={handleSend}
              />
            )}
          </div>
        ) : (
          <div>
            <Grid container justify="center">
              {
                <Grid item xs={12} style={{ marginTop: "1rem" }}>
                  {(afiliadoEncontrado) && <BannerAfiliado fromPreafiliaciones={true} />}
                </Grid>
              }
              {getStepContent(step)}
            </Grid>
            {!mostrarNext && <Grid
              className={classes.buttonRoot}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Button
                variant="contained"
                disabled={step === 0}
                onClick={handleBack}
                className={classes.button}
                color="secondary"
              >
                anterior
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
                disabled={habilitado}
              >
                {step === steps.length - 1 ? "Finalizado" : "Siguiente"}
              </Button>
            </Grid>}
          </div>
        )}
      </div>
      {redirectBandeja && (
        <Redirect
          to={{
            pathname: "/afiliaciones/bandeja",
          }}
        />
      )}
      {redirectAfiliaciones && (
        <Redirect
          to={{
            pathname: "/afiliaciones",
          }}
        />
      )}
    </div>
  );
}
